import { InputType } from 'config'

export const defaultProductInputs = (): Record<string, InputType> => {
  return {
    productName: {
      inputType: 'text',
      type: 'text',
      title: 'Default Product Name',
      value: '',
      required: true,
    },
    lockTerm: {
      inputType: 'text',
      type: 'number',
      title: 'Default Lock Days',
      value: '',
      required: true,
    },
  }
}

export const defaultLockExtensionInputs = (): Record<string, InputType> => {
  return {
    maxExtensionDays: {
      inputType: 'text',
      type: 'number',
      title: 'Max Extension Combined Days',
      value: '',
      required: true,
    },
    maxExtensionCount: {
      inputType: 'text',
      type: 'number',
      title: 'Max Extension Count',
      value: '',
      required: true,
    },
  }
}

export const defaultProgramInputs = (): Record<string, InputType> => {
  return {
    section: {
      inputType: 'section',
      title: 'Program',
      span: 'full',
    },
    id: {
      inputType: 'text',
      type: 'number',
      title: 'ID',
      value: '',
    },
    programName: {
      inputType: 'text',
      type: 'text',
      title: 'Default Program Name',
      value: '',
      required: true,
    },
    rate: {
      inputType: 'text',
      type: 'number',
      title: 'Default Rate',
      value: '',
      required: true,
    },
    price: {
      inputType: 'text',
      type: 'number',
      title: 'Default Price',
      value: '',
      required: true,
    },
    rateSpread: {
      inputType: 'text',
      type: 'number',
      title: 'Default Rate Spread',
      value: '',
      required: true,
    },
    exitFee: {
      inputType: 'text',
      type: 'number',
      title: 'Default Exit Fee',
      value: '',
      required: true,
    },
  }
}
